
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class ValidationMessage extends Vue {
  @Prop({ default: "" })
  message!: String;

  @Prop({ default: -1 })
  status!: number;

  mounted() {
    this.scrollToView();
  }

  public scrollToView(): void {
    if (this.$refs["validate-component"]) {
      const $el = this.$refs["validate-component"] as Element;
      $el.scrollIntoView({ behavior: "smooth" });
    }
  }

  @Watch("message", {
    deep: true,
  })
  onPropertyChanged() {
    console.log("dsdsdds");
    this.scrollToView();
  }
}
